export default __webpack_public_path__ + "static/media/facial_prop.084a3a18.svg";